import { all } from "redux-saga/effects";

import * as watchers from "./watchers";

export function* themeManagementSagas() {
  yield all([
    watchers.watchAddNewLogo(),
    watchers.watchApplyFontToSection(),
    watchers.watchPatchOrganization(),
    watchers.watchPatchStyle(),
    watchers.watchLoadOrgFontFamilies(),
    watchers.watchMount(),
    watchers.watchUpdateStyles(),
    watchers.watchUnmount(),
  ]);
}
